import axios from 'axios';

const errorHandler = (error) => {
    const { message, request, response } = error;

    if (response) {
        const { message, expired } = response.data;
        const status = response.status;

        return {
            message,
            status,
            expired
        }
    } else if (request) {
        //request sent but no response received
        return {
            message: message,
            status: 503
        }
    } else {
        // Something happened in setting up the request that triggered an Error
        return {
            message: "opps! something went wrong while setting up request",
            status: ''
        }
    }
};

export default errorHandler